export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: null
    },
    isClick: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleBack() {
      if (this.isClick) {
        return this.$emit('back');
      }
      // const { isupload, id, from, type } = this.$route.query;

      // console.log(isupload == true)
      // if (isupload == true) {
      //   console.log(isupload)
      //   return this.$router.push({
      //     query: { ...this.$route.query, isupload: false },
      //   });
      // }
      if (this.path) {
        this.$router.push(this.path);
      } else {
        this.$router.go(-1);
      }
    }
  }
};